<script>
import useTools from "@/use/Tools";
import {ref} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import {usePaySlipStore} from "@/stores/PaySlip";
import axios from "axios";

export default {
    props: {
        filter: Object,
        workers: Array,
        annexId: Number,
        type: String,
    },
    setup(props) {
        const {$refs} = useTools();
        const {getBack, transformFilterValues} = useSharedMethod();
        const loading = ref(false);
        const updateOption = ref('KEEP');
        const paySlipStore = usePaySlipStore();
        
        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                const ids = props.workers.map((w) => w.id);
                const body = {
                    ids: ids,
                    annexId: props.annexId,
                    type: props.type,
                    updateOption: updateOption.value
                };
                axios.put(`/payments/addRefundPaySections`, body, {
                    params: transformFilterValues(props.filter),
                }).then(response => {
                    paySlipStore.updateAll(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        return {
            loading,
            updateOption,
            save
        }
    }
    
};
</script>

<template>
    <v-form ref="form" lazy-validation>
        <v-row>
            <v-col cols="12">
                <v-radio-group v-model="updateOption" column class="mt-n2" hide-details>
                    <v-radio value="KEEP" :label="$t('common.keep')" color="blue"/>
                    <v-radio value="ERASE" :label="$t('common.replace')" color="red"/>
                    <v-radio value="SUM" :label="$t('common.accumulate')" color="teal"/>
                </v-radio-group>
            </v-col>
            <v-col cols="12">
                <w-btn-import
                    block
                    :loading="loading"
                    @press="save"
                />
            </v-col>
        </v-row>
    </v-form>
</template>